import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   redirect: '/home'
  // },
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: Home
  // }
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    // Canonical path for endorsements.
    path: '/recommendations',
    name: 'Recommendations',
    component: () => import('../views/References.vue')
  },
  // Aliases → redirect to the canonical path.
  { path: '/references', redirect: '/recommendations' },
  { path: '/referrals', redirect: '/recommendations' },
  { path: '/reference', redirect: '/recommendations' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
